/******************************************************
 *                  Coherence Detail Ctrl
 ********************************************************/

"use strict";

angular.module("coherence")
	.controller("CoherenceDetailCtrl", [
		"$scope", "$log", "toastr", "Utils", "$uibModal", "$location", "CoherenceService", "type", "item",
		function ($scope, $log, toastr, Utils, $uibModal, $location, CoherenceService, type, item) {
			$scope.data = {
				type: type,
				item: item.data,
				showSQLDetail: false,
				showResults: false,
				loadingResults: false,
			};

			$scope.loadDetailResults = () => {
				$scope.data.loadingResults = true;
				CoherenceService.loadDetailResults($scope.data.item.id)
					.then((response) => {
						const data = response.data;
						$scope.data.showResults = true;

						let results = [];
						let resultHeaders = [];
						for (let rowIndex in data) {
							let rowObject = JSON.parse(data[rowIndex]);
							if (resultHeaders.length === 0) {
								for (let header in rowObject) {
									resultHeaders.push(header);
								}
							}

							results.push(rowObject);
						}

						$scope.data.results = results;
						$scope.data.resultHeaders = resultHeaders;
					})
					.catch((response) => {
						const error = response.data;
						$scope.data.showResults = false;
						if (error.code === 10) { // Cas d'une vue pas encore chargée
							toastr.info("La vue n'est pas encore chargée.");
							$scope.refreshView();
						} else {
							toastr.error(Utils.makeErrorMessage(error, ""));
						}
					}).finally(() => $scope.data.loadingResults = false);
			};

			$scope.loadDetailResults();

			/**
			 * Rafraichis la vue matérialisé des résultats
			 */
			$scope.refreshView = () => {
				toastr.info("Rechargement de la vue. Ce traitement peut prendre plusieurs minutes.");
				CoherenceService.refreshCoherenceView($scope.data.item.id)
					.then(() => {
						$log.info("Fin du rechargement de la vue. Récupération des résultats.");
						$scope.loadDetailResults();
					})
					.catch(() => {
						$log.info("Le calcul a bien été lancé, veuillez rafraichir cette page d'ici quelques minutes.");
					});
			};

			/**
			 * Retourne un nom compréhensible du dataType retourné
			 * @returns {string}
			 */
			$scope.getDataPrettyName = () => {
				switch ($scope.data.item.dataClassStr) {
					case "Institution.class":
						return "Établissement";
					case "Subscriber.class":
						return "Abonné";
					case "OkinaJourneyPattern.class":
						return "Itinéraire";
					case "OkinaStopArea.class":
						return "Point d'arrêt";
					case "OkinaVehicleJourney.class":
						return "Course";
					default:
						return "Type de données non reconnu.";
				}
			};

			/**
			 * Tente d'accéder à la page d'édition de l'élément concerné
			 * @param index
			 */
			$scope.goToRowItem = (index) => {
				let nextURL = "";

				// Le premier champs doit forcément être l'identifiant de l'objet
				const firstHeaderId = $scope.data.resultHeaders[0];
				const id = $scope.data.results[index][firstHeaderId];

				switch ($scope.data.item.dataClassStr) {
					case "Institution.class":
						nextURL = "/school-iti/institutions/" + id;
						break;
					case "Subscriber.class":
						nextURL = "/school-iti/subscriptions/abonne/" + id;
						break;
					case "OkinaJourneyPattern.class":
						nextURL = "/e-iti/itineraires/" + id;
						break;
					case "OkinaStopArea.class":
						nextURL = "/e-iti/arrets";
						break;
					case "OkinaVehicleJourney.class":
						nextURL = "/e-iti/courses";
						break;
					default:
						toastr.error("Type de données non reconnu. Impossible d'y accéder.");
						break;
				}

				if (nextURL.length !== 0) {
					$location.path(nextURL);
				}
			};
		}]
	)
;
